module.exports = __webpack_public_path__ + "static/media/product_detail_edit.c939e02b.svg";